import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const GateContext = /*#__PURE__*/createContext({});
export function GateProvider({
  isEnterpriseManagedAuthUngated,
  children
}) {
  return /*#__PURE__*/_jsx(GateContext.Provider, {
    value: {
      isEnterpriseManagedAuthUngated
    },
    children: children
  });
}
export function useGates() {
  return useContext(GateContext);
}